import React from 'react';
import SiteHtmlPage from '../components/siteContent/SiteHtmlPage';

const PrivacyPage = () => <SiteHtmlPage slug="privacy" />;

export default PrivacyPage;
